import { useEffect } from 'react';

const useStyleSheet = (linkId, src) => {
  useEffect(() => {
    if (!document.querySelector(`link[href="${src}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = src;
      link.id = linkId;
      window.document.body.appendChild(link);
    }

    return () => {
      window.document.getElementById(linkId)?.remove();
    };
  }, []);
};

export default useStyleSheet;
